module.exports = __webpack_public_path__ + "static/img/menu_icon5.59e2a454.png";